export const QUERY_KEY = {
  // PATCH 자동적립 설정 저장 / GET 상태 조회 모두 v2로 이관 완료.
  AUTO_SAVE: '/v2/viewing/auto/settings',
  AUTO_SAVE_STATUS: (uuid: string) => `/v2/viewing/auto/settings?snsAccountUuid=${uuid}`,
  BANK: '/v2/banks',
  // POST 계좌 등록 / GET 목록 모두 v2로 이관 완료. DELETE(BANK_DELETE)는 v2 엔드포인트 부재로 아직 v1.
  BANK_ACCOUNT_V2: '/v2/bank-accounts',
  BANK_DELETE: (uuid: string) => `/bank-account/${uuid}`,
  BANNERS: '/v2/banners',
  COMMUNITIES_IMAGE_URL: '/image-url?categoryName=community',
  FAQ: '/faqs',
  INFORMATION: '/users/information',
  ME: '/users/me',
  NOTIFICATIONS: '/notifications',
  POINT_COUNT: '/point/count',
  POINT_EARNED: '/v2/point/logs/list',
  POINT_TREND: '/point/trend',
  REFRESH: '/v2/auth/refresh',
  SNS_ACCOUNTS_VIEWUP: '/sns-accounts/viewup',
  SNS_ACCOUNTS_VIEWUP_PLUS: '/sns-accounts/viewupPlus',
  VIEWING_LOCK_TIME: (userUuid: string) => `/v2/viewing/click/lock-time?userUuid=${userUuid}`,
} as const;
